import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import { useActionPanel } from '../ActionPanelProvider'
import { MAX_ACTION_MENU_SLOTS } from '../getActionPanelWidth'
import { ActionIconButton } from './ActionIconButton'
import { ActionMenuDropdown } from './ActionMenuDropdown'
import { Menu } from './ui'

/**
 * The registry, rendered for one row.
 *
 * Every registered action reaches every row, in `order`: inline while the row
 * has a slot for it, and behind the ellipsis once it does not. An action that is
 * unavailable for this listing renders disabled rather than absent, so the icons
 * line up down the column either way.
 *
 * The split is `MAX_ACTION_MENU_SLOTS` alone — the ellipsis claims a slot, so it
 * displaces the action that would have filled it.
 */
export const ActionMenu = ({
  searchListing,
}: {
  searchListing: CombinedListingSearchResult
}) => {
  const { getActions, variant } = useActionPanel()

  if (variant === 'minimized') return null

  const actions = getActions(searchListing)
  if (actions.length === 0) return null

  const slots = MAX_ACTION_MENU_SLOTS[variant]
  const hasDropdown = actions.length > slots
  const inlineActions = hasDropdown ? actions.slice(0, slots - 1) : actions

  return (
    <Menu>
      {inlineActions.map((action) => (
        <ActionIconButton action={action} key={action.id} />
      ))}
      {hasDropdown && <ActionMenuDropdown actions={actions.slice(slots - 1)} />}
    </Menu>
  )
}
